import React from "react";
import "./ourclient.css";

import one from "../../assets/ourclients/accenture.webp";
import two from "../../assets/ourclients/amazon.webp";
import three from "../../assets/ourclients/avasoft.webp";
import four from "../../assets/ourclients/capegimin.webp";
import five from "../../assets/ourclients/client-1.png";
import six from "../../assets/ourclients/client-2.png";
import seven from "../../assets/ourclients/client-3.png";
import eight from "../../assets/ourclients/client-4.png";
import nine from "../../assets/ourclients/client-5.png";
import ten from "../../assets/ourclients/client-6.png";
import elven from "../../assets/ourclients/client-7.png";
import twele from "../../assets/ourclients/client-8.png";
import thirteen from "../../assets/ourclients/cts.webp";
import fourteen from "../../assets/ourclients/hcl.webp";
import fifteen from "../../assets/ourclients/syntel.webp";
 
  


function OurClient() {
  const logos = [
    one, two, three, four, five, six, seven, eight,  nine, ten, elven,
    twele, thirteen, fourteen, fifteen
  ];


  
    
     

  return (
    <section className="ourclient-section" data-aos = "fade-up">
      <div className="container">
       <section className="section-margin">
         <div className="headlines-for-all">
  <h4>
    <span>Our </span> Clients
  </h4>
  <p>
    We’re proud to have trained and collaborated with leading IT companies and 
    growing startups. Our students are placed in top organizations that trust 
    our commitment to quality learning and job-ready skills.
  </p>
</div>

        </section>

        <div className="client-grid">
          {logos.map((logo, index) => (
            <div className="client-card" key={index}>
              <img src={logo} alt={`Client ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurClient;
